"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeframePicker = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const dayjs_1 = __importDefault(require("dayjs"));
const styled_components_1 = __importDefault(require("styled-components"));
const { RangePicker } = elements_1.DayjsDatePicker;
function disabledDate(current) {
    return current && current > (0, dayjs_1.default)().endOf('day');
}
const RangePickerWrapper = styled_components_1.default.div `
	flex: 0 0 auto;
`;
const TimeframePicker = ({ setDate, dateTo, dateFrom, dateFormat, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const [localDateFrom, setLocalDateFrom] = react_1.default.useState(dateFrom);
    const [localDateTo, setLocalDateTo] = react_1.default.useState(dateTo);
    const handleOnChange = (dates) => {
        if (dates && dates.length) {
            setLocalDateFrom(dates[0]);
            setLocalDateTo(dates[1]);
        }
        else {
            setLocalDateFrom(null);
            setLocalDateTo(null);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between align-center flex-wrap ", children: [(0, jsx_runtime_1.jsx)(RangePickerWrapper, { children: (0, jsx_runtime_1.jsx)(RangePicker, { className: "m-r-m", defaultValue: [(0, dayjs_1.default)(dateFrom, dateFormat), (0, dayjs_1.default)(dateTo, dateFormat)], picker: "date", onChange: (_, dates) => handleOnChange(dates), format: dateFormat, disabledDate: disabledDate, defaultPickerValue: [(0, dayjs_1.default)().subtract(1, 'month').startOf('month'), (0, dayjs_1.default)()], ranges: {
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_today',
                        })]: [(0, dayjs_1.default)(), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_this_week',
                        })]: [(0, dayjs_1.default)().isoWeekday(1), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_this_month',
                        })]: [(0, dayjs_1.default)().startOf('month'), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_this_year',
                        })]: [(0, dayjs_1.default)().startOf('year'), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_yesterday',
                        })]: [(0, dayjs_1.default)().subtract(1, 'day').startOf('day'), (0, dayjs_1.default)().subtract(1, 'day').endOf('day')],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_previous_week',
                        })]: [(0, dayjs_1.default)().isoWeekday(1).subtract(1, 'week'), (0, dayjs_1.default)().isoWeekday(7).subtract(1, 'week')],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_previous_month',
                        })]: [
                            (0, dayjs_1.default)().subtract(1, 'month').startOf('month'),
                            (0, dayjs_1.default)().subtract(1, 'month').endOf('month'),
                        ],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_previous_year',
                        })]: [(0, dayjs_1.default)().subtract(1, 'year').startOf('year'), (0, dayjs_1.default)().subtract(1, 'year').endOf('year')],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_past_week',
                        })]: [(0, dayjs_1.default)().subtract(1, 'week'), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_past_month',
                        })]: [(0, dayjs_1.default)().subtract(1, 'month'), (0, dayjs_1.default)()],
                        [intl.formatMessage({
                            id: 'admin.analytics.timeframe_past_year',
                        })]: [(0, dayjs_1.default)().subtract(1, 'year'), (0, dayjs_1.default)()],
                    } }) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-s m-b-s", size: "middle", type: "success", disabled: !localDateFrom && !localDateTo, onClick: () => {
                    setDate([localDateFrom, localDateTo]);
                }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.analytics.timeframe_apply" }) })] }));
};
exports.TimeframePicker = TimeframePicker;
